// lazy-load.directive.ts
import { onMounted, onUnmounted, ref } from 'vue';

interface LazyLoadOptions {
  threshold?: number | number[];
}

export const useLazyLoad = (elRef: Ref<HTMLElement | null>, options: LazyLoadOptions = {}) => {
  const isIntersecting = ref(false);

  if (!import.meta.env.SSR) {

    const observer = new IntersectionObserver(
      ([entry]) => {
        isIntersecting.value = entry.isIntersecting;
      },
      options
    );

    onMounted(() => {
      if (elRef.value) {
        observer.observe(elRef.value);
      }
    });

    onUnmounted(() => {
      if (elRef.value && observer) {
        observer.unobserve(elRef.value);
      }
    });

  }

  return isIntersecting;
};
